import styled from 'styled-components/macro'
export const WomanContainer = styled.div`
  img {
    width: 310px;
    @media (max-width: 1600px) {
      width: 240px;
    }
    @media (max-width: 1280px) {
      width: 200px;
    }
    @media (max-width: 1024px) {
      width: 146px;
    }
  }
`
export const PlateContainer = styled.div`
  text-align: center;
  img {
    width: 310px;
    @media (max-width: 1600px) {
      width: 240px;
    }
    @media (max-width: 1280px) {
      width: 200px;
    }
    @media (max-width: 1024px) {
      max-width: 100%;
      width: 360px;
    }
  }
`
export const PotContainer = styled.div`
  height: 350px;
  overflow-y: clip;
  @media (max-width: 1600px) {
    height: 270px;
  }
  @media (max-width: 1280px) {
    height: 230px;
  }
  @media (max-width: 1024px) {
    height: 172px;
  }
  img {
    width: 310px;
    top: 50px;
    @media (max-width: 1600px) {
      width: 240px;
      top: 40px;
    }
    @media (max-width: 1280px) {
      width: 200px;
      top: 30px;
    }
    @media (max-width: 1024px) {
      //position: absolute;
      top: 15px;
      //left: 50%;
      width: 146px;
      transform: translateX(-73px);
    }
  }
`
